<template>
    <div>
        <div class="row">
            <form-select
                v-model="sexo"
                :grid="aba == 'Programas Sociais' ? 4 : 6"
                label="Sexo do Responsável"
                @selected="$emit('sexo', { sexo: sexo })"
                :itens="$root.arrays.sexo"
                :required="true"
            />
            <form-select
                v-model="cor_raca"
                :grid="aba == 'Programas Sociais' ? 4 : 6"
                label="Cor ou Raça"
                @selected="$emit('cor', { cor: cor_raca })"
                :itens="$root.arrays.cor_raca"
                :required="true"
            />
            <form-select
                v-if="aba == 'Programas Sociais'"
                v-model="programa_social"
                grid="4"
                label="Programas sociais"
                @selected="
                    $emit('programa_social', {
                        programa_social: programa_social,
                    })
                "
                :itens="programas"
                :required="true"
            />
        </div>
        <div class="row">
            <form-toggle
                v-model="situacao_rua"
                label="Situação de Rua"
                grid="4"
                class="mt-0"
                @input="$emit('situacao_rua', { situacao_rua: situacao_rua })"
            />
            <form-toggle
                v-model="trabalho_infantil"
                label="Trabalho infantil"
                grid="4"
                class="mt-0"
                @input="
                    $emit('trabalho_infantil', {
                        trabalho_infantil: trabalho_infantil,
                    })
                "
            />
            <form-toggle
                v-model="idoso"
                label="Famílias com pessoas idosas"
                grid="4"
                class="mt-0"
                @input="
                    $emit('idoso', {
                        idoso: idoso,
                    })
                "
            />
        </div>
        <div class="row">
            <div class="col-md-12 px-4">
                <label class="d-block font-weight-bold">Faixa Etária</label>
                <vue-slider
                    v-model="idade"
                    :min="minIdade"
                    :max="maxIdade"
                    :tooltip="'always'"
                    tooltip-placement="top"
                    @drag-end="
                        $emit('idade', {
                            idade: idade,
                        })
                    "
                />
            </div>
        </div>
        <div class="row mt-4 px-3 d-flex justify-content-end">
            <button
                class="btn btn-danger mx-0"
                @click="
                    $emit('limpar');
                    cancelar();
                "
            >
                <i class="mdi mdi-close"></i> Limpar
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["limpar", "aba", "programas"],
    data() {
        return {
            sexo: "",
            posicao_familiar: "",
            cor_raca: "",
            situacao_rua: "",
            trabalho_infantil: "",
            idoso: "",
            programa_social: "",
            idade: [0, 120],
            minIdade: 0,
            maxIdade: 120,
        };
    },
    watch: {
        limpar() {
            if (this.limpar) {
                this.cancelar();
            }
        },
    },
    mounted() {
        if (this.limpar) {
            this.cancelar();
        }
    },
    methods: {
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("limpo");
        },
    },
};
</script>
<style>
.custom-step {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 0 0 0 3px #ccc;
    background-color: #fff;
}
.custom-step.active {
    box-shadow: 0 0 0 3px #3498db;
    background-color: #3498db;
}
</style>
